// Get Blog
export const FETCH_BLOG_BEGIN = 'FETCH_BLOG_BEGIN'
export const RECEIVE_BLOG = 'RECEIVE_BLOG'
export const FETCH_SINGLE_BLOG = 'FETCH_SINGLE_BLOG'


